<!--
 * @Description: 操作按钮
 * @Author: chenguobiao
 * @Date: 2021-07-15 10:42:38
 * @LastEditTime: 2022-02-11 14:48:46
 * @LastEditors: chenguobiao
-->
<template>
  <div class="option-button" @click="handleClick">
    <div class="option-button__bg">
      <img src="@/render/assets/images/grading/button_bg.png">
    </div>
    <div class="option-button__text">{{txt}}</div>
  </div>
</template>

<script>
export default {
  props: ['txt'],
  methods: {
    handleClick() {
      this.$emit('handleClick')
    }
  },
}
</script>

<style lang="scss" scoped>
  .option-button {
    position: relative;
    width: val(236);
    cursor: pointer;
    margin: 0 auto;
    &__text {
      position: absolute;
      top: calc(50% - 0.02rem);
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: val(24);
      font-weight: 400;
      color: #FFEFDB;
    }
  }
</style>
